/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Designer_Touch_HintInputs */

const cs_pipelines_designer_touch_hint = /** @type {(inputs: Pipelines_Designer_Touch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klepnutím upravte fázi. ← → změní pořadí.`)
};

const en_pipelines_designer_touch_hint = /** @type {(inputs: Pipelines_Designer_Touch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap a stage to edit. Use ← → to reorder.`)
};

/**
* | output |
* | --- |
* | "Tap a stage to edit. Use ← → to reorder." |
*
* @param {Pipelines_Designer_Touch_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_designer_touch_hint = /** @type {((inputs?: Pipelines_Designer_Touch_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Designer_Touch_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_designer_touch_hint(inputs)
	return cs_pipelines_designer_touch_hint(inputs)
});